import React, {Component} from 'react';
import {Radio, Input} from "antd";

class RmOtherAttributes extends Component {

    constructor(props) {
        super(props);
        this.state = {
            meanWhile: false,
            synchronize: true,
            contribute: true,
            properties: true,
            orso: true,
            switchShow: false,
            publishInformation: {
                top: 0,
                recommend: 0,
                // 点击量 int
                initViewNum: 0,
                //总浏览量
                viewNum: 0
            }
        }
    }

    getData=()=> {
        return this.state.publishInformation
    };

    setData =(data) => {
        let {top = 0, recommend = 0, initViewNum = 0, viewNum = 0} = data;
        this.state.publishInformation = {
            ...this.state.publishInformation,
            top,recommend,initViewNum,viewNum
        };
        this.setState({});
    };

    onChange = ({value, key}) => {
        this.state.publishInformation[key] = value;
        this.setState({})
    };

    render() {
        let {publishInformation} = this.state;
        return (
            <div style={{padding: "0px 10px"}}>
                {/*暂时屏蔽*/}
                {/*<div className="tapeOut">*/}
                {/*    <div className="unifiedStyle">设置置顶</div>*/}
                {/*    <Radio.Group*/}
                {/*        className="elseReleaseTime"*/}
                {/*        onChange={e =>*/}
                {/*            this.onChange({*/}
                {/*                value: e.target.value * 1,*/}
                {/*                key: 'top'*/}
                {/*            })*/}
                {/*        }*/}
                {/*        value={publishInformation.top}*/}
                {/*    >*/}
                {/*        <Radio value={1}>是</Radio>*/}
                {/*        <Radio value={0}>否</Radio>*/}
                {/*    </Radio.Group>*/}
                {/*</div>*/}
                {/*<div className="tapeOut">*/}
                {/*    <div className="unifiedStyle">设置推荐</div>*/}
                {/*    <Radio.Group*/}
                {/*        className="elseReleaseTime"*/}
                {/*        onChange={e =>*/}
                {/*            this.onChange({*/}
                {/*                value: e.target.value * 1,*/}
                {/*                key: 'recommend'*/}
                {/*            })*/}
                {/*        }*/}
                {/*        value={publishInformation.recommend}*/}
                {/*    >*/}
                {/*        <Radio value={1}>是</Radio>*/}
                {/*        <Radio value={0}>否</Radio>*/}
                {/*    </Radio.Group>*/}
                {/*</div>*/}
                <div className="tapeOut">
                    <div>初始浏览量</div>
                    <Input
                        className="elseReleaseTime"
                        onChange={(e) => {
                            let initViewNum = 0;
                            if(e.target.value) {
                                initViewNum = e.target.value;
                                initViewNum = initViewNum.replace(/[^[0-9]]*/,"");// 去除非数字
                                initViewNum = initViewNum.replace(/^[0]([0]+)/,"");// 去除连续0
                                initViewNum = initViewNum.replace(/^([0])([1-9]+)/,"$2");// 去除首个0
                                if(parseInt(initViewNum) > 100000000){
                                    // message.warn("请输入正确的点击次数（0-100,000,000）！");
                                    return;
                                }
                            }
                            this.onChange({
                                value: initViewNum * 1,
                                key: 'initViewNum'
                            })
                        }}
                        value={publishInformation.initViewNum || 0}
                    />
                </div>
                <div className="tapeOut">
                    <div>总浏览量</div>
                    <div style={{fontSize: 14}}>{publishInformation.viewNum}</div>
                </div>
            </div>
        );
    }
}

export default RmOtherAttributes;
